module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};



//////////////////
// WEBPACK FOOTER
// ./~/html-to-react/~/ramda/src/internal/_has.js
// module id = 154
// module chunks = 0